<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1">

            <!-- <a-descriptions-item label="类型">
                <dict-render :dict-obj="dictObjs['loanType']" :text="form.type"></dict-render>
            </a-descriptions-item> -->
            <a-descriptions-item label="产品名称">{{form.productName}}</a-descriptions-item>
            <a-descriptions-item label="最高贷款金额(万元)">{{form.maxLoanLines}}</a-descriptions-item>
            <a-descriptions-item label="贷款利率">{{form.rate}}</a-descriptions-item>
            <a-descriptions-item label="联系方式">{{form.contact}}</a-descriptions-item>
            <!-- <a-descriptions-item label="担保方式">
                <dict-render :dict-obj="dictObjs['guarantee']" :text="form.guarantyType"></dict-render>
            </a-descriptions-item> -->
            <!-- <a-descriptions-item label="贷款期">
                <dict-render :dict-obj="dictObjs['loanDeadline']" :text="form.guarantyType"></dict-render>
            </a-descriptions-item> -->
            <a-descriptions-item label="还款方式">
                <dict-render :dict-obj="dictObjs['paymentType']" :text="form.paymentType"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="产品详细介绍">{{form.details}}</a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
import {
        dictMixin,formMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";

export default {
    name: "Detail",
    mixins: [
        dictMixin,formMixin],
    components:{DictRender},
    data() {
        return {
            dictNames: 'guarantee,loanDeadline,paymentType,loanType',
            form: {
                id: null,
                img: null,
                companyCode: null,
                productId: null,
                mechanismId: null,
                maxLoanLines: null,
                rate: null,
                type: null,
                contact: null,
                productName: null,
                details: null,
                guarantyType: null,
                loanDeadline: null,
                paymentType: null,
            },
        }
    },
    methods:{
        onClose(){
            this.visible = false
            this.$emit("onCloseModel")
        }
    }
}
</script>

<style scoped lang="less">

</style>
